/// <reference path="events.ts" />
import { CustomTypedEvent } from './events';
//namespace Pacem {
export const CommandEventName = 'command';
export class CommandEvent extends CustomTypedEvent {
    constructor(args) {
        super(CommandEventName, args, { bubbles: true, cancelable: true });
    }
}
//}
